import { useTranslation } from "react-i18next";
import { namespaces } from "../i18n.costants";
import { Card } from './Card';
import { LazyImage, ImageContainer, ImageDummy } from './ImageContainer';
import industry1 from '../media/photos/soluzioni_industriali_cucina_1.jpg';
import industry2 from '../media/photos/soluzioni_industriali_cucina_2.jpg';
import industry3 from '../media/photos/soluzioni_industriali_cucina_3.jpg';
import industry4 from '../media/photos/soluzioni_industriali_cucina_4.jpg';
import industry5 from '../media/photos/soluzioni_industriali_cucina_5_cropped.jpg';
import industry6 from '../media/photos/soluzioni_industriali_uffici_1.jpg';
import industry7 from '../media/photos/soluzioni_industriali_uffici_2.jpg';
import industry8 from '../media/photos/soluzioni_industriali_uffici_3.jpg';
import industry9 from '../media/photos/soluzioni_industriali_uffici_4.jpg';
import industry10 from '../media/photos/soluzioni_industriali_uffici_5.jpg';
import industry11 from '../media/photos/soluzioni_industriali_uffici_6.jpg';
import industry12 from '../media/photos/soluzioni_industriali_uffici_7.jpg';
import ac1 from '../media/photos/aria_condizionata_1.jpg';
import ac2 from '../media/photos/aria_condizionata_2_cropped.jpg';
import ac3 from '../media/photos/aria_condizionata_3.jpg';
import ac4 from '../media/photos/aria_condizionata_4.jpg';
import ac5 from '../media/photos/aria_condizionata_5.jpg';
import { ReactComponent as Uffici } from '../media/ristrutturazione_uffici_sedia.svg';
import { Layout } from './Layout';
import { FullBleedCard } from './FullBleedCard';

export function RenovationOffice() {
  const { t } = useTranslation(namespaces.common);

  return (
    <>
      <FullBleedCard
        id={t("nav/office-renovation")}
        header={t("Arredo ufficio")}
        title={t("Soluzioni per l'ufficio")}
        text={t("__Descrizione_ufficio__")}
        icon={<Uffici />}
      />

      <Layout>
        <Card title={t("Cucina")}>
          <ImageContainer>
            <LazyImage src={industry2} alt="soluzioni-industriali-2" />
            <LazyImage src={industry3} alt="soluzioni-industriali-3" />
          </ImageContainer>

          <ImageContainer>
            <LazyImage src={industry1} alt="soluzioni-industriali-1" />
            <LazyImage src={industry5} alt="soluzioni-industriali-5" />
          </ImageContainer>

          <ImageContainer>
            <LazyImage src={industry4} alt="soluzioni-industriali-4" />
            <ImageDummy />
          </ImageContainer>

        </Card>

        <Card title={t("Uffici con pannelli divisori in vetro")} id={t("nav/office")}>
          <ImageContainer>
            <LazyImage src={industry7} alt="soluzioni-industriali-7" />
            <LazyImage src={industry11} alt="soluzioni-industriali-11" />
          </ImageContainer>

          <ImageContainer>
            <LazyImage src={industry12} alt="soluzioni-industriali-12" />
            <LazyImage src={industry8} alt="soluzioni-industriali-8" />
          </ImageContainer>

          <ImageContainer>
            <LazyImage src={industry9} alt="soluzioni-industriali-9" />
            <LazyImage src={industry10} alt="soluzioni-industriali-10" />
          </ImageContainer>

          <ImageContainer>
            <LazyImage src={industry6} alt="soluzioni-industriali-6" />
            <ImageDummy />
          </ImageContainer>
        </Card>

        <Card
          title={t("Sistema di condizionamento")}
          subtitle={t("con detrazioni fiscali")}
          id={t("nav/air-conditioning")}
        >
          <ImageContainer>
            <LazyImage src={ac1} alt="aria-condizionata-1" />
            <LazyImage src={ac2} alt="aria-condizionata-2" />
          </ImageContainer>

          <ImageContainer>
            <LazyImage src={ac3} alt="aria-condizionata-3" />
            <LazyImage src={ac4} alt="aria-condizionata-4" />
          </ImageContainer>

          <ImageContainer>
            <LazyImage src={ac5} alt="aria-condizionata-5" />
            <ImageDummy />
          </ImageContainer>
        </Card>
      </Layout>
    </>
  )
}
